import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function GameOverWebdb() {






    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Game Over Web data base</h2>
                <div className='folder-porfolio'>


                    <div className="imageProyect imageGameOverweb"></div>
                    <div className="list" >



                        {tecno.filter(tec => tec.T === 'MySql').map(tec => (


                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        This MySql database belongs to the gameoverweb application made with the help of the Django ORM.
                    </p>

                    <a href="https://github.com/BrandonGrimaldoM/GameOverWebDataBase" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>

                <div className='after'>
                    <Link to="/data-base" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>


            </section>
        </React.Fragment>
    );
}
export default GameOverWebdb;